var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaperClip(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x31__x2C_5_px",
    enableBackground: "new 0 0 24 24",
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m20.5 24c-1.93 0-3.5-1.57-3.5-3.5v-5.25c0-1.24 1.01-2.25 2.25-2.25s2.25 1.01 2.25 2.25v5c0 .414-.336.75-.75.75s-.75-.336-.75-.75v-5c0-.413-.337-.75-.75-.75s-.75.337-.75.75v5.25c0 1.103.897 2 2 2s2-.897 2-2v-6.75c0-.414.336-.75.75-.75s.75.336.75.75v6.75c0 1.93-1.57 3.5-3.5 3.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m14.81 22h-12.06c-1.517 0-2.75-1.233-2.75-2.75v-16.5c0-1.517 1.233-2.75 2.75-2.75h12.5c1.517 0 2.75 1.233 2.75 2.75v8.48c0 .414-.336.75-.75.75s-.75-.336-.75-.75v-8.48c0-.689-.561-1.25-1.25-1.25h-12.5c-.689 0-1.25.561-1.25 1.25v16.5c0 .689.561 1.25 1.25 1.25h12.06c.414 0 .75.336.75.75s-.336.75-.75.75z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m14.25 15h-10.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h10.5c.414 0 .75.336.75.75s-.336.75-.75.75z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m14.25 11h-10.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h10.5c.414 0 .75.336.75.75s-.336.75-.75.75z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m9.25 7h-5.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h5.5c.414 0 .75.336.75.75s-.336.75-.75.75z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperClip);
export default __webpack_public_path__ + "static/media/paper-clip.17ef78177e375c34a05dc0e0e884eaaf.svg";
export { ForwardRef as ReactComponent };